import api from "api";

const teams = {
    get: () => {
        return api().get('/teams')
    },

    create: (payload) => {
        return api().post('/teams', payload)
    },

    update: (id, payload) => {
        return api().put(`/teams/${id}`, payload)
    },

    delete: (id) => {
        return api().delete(`/teams/${id}`)
    },

    addMember: (teamId, payload) => {
        return api().post(`/teams/${teamId}/members`, payload)
    },

    removeMember: (teamId, memberId) => {
        return api().delete(`/teams/${teamId}/members/${memberId}`)
    },

    addGrant: (teamId, payload) => {
        return api().post(`/teams/${teamId}/grants`, payload)
    },

    removeGrant: (teamId, grantId) => {
        return api().delete(`/teams/${teamId}/grants/${grantId}`)
    },
}

export default teams;
